import React, { useCallback, useContext, useEffect, useState } from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

import { useAppDispatch } from 'redux/store';
import { updatePlatformLanguage } from 'redux/actions/users';
import { AngularServicesContext } from 'react-app';
import useLanguageTranslation from 'automated_translation/hooks/use-language-translation';

import { gray1 } from 'styles/global_defaults/colors';

import { NvSavingOverlay } from 'shared/components/nv-saving-overlay';
import NvDropdown, { NvDropdownAlign, NvDropdownButtonStyle, NvDropdownOption } from 'shared/components/inputs/nv-dropdown';

import { config } from '@config/config.json';


const LanguagePreferences = () => {
  const styles = css`
    .nv-dropdown {
      width: 200px;
      margin: auto;
    }
    .bs4-dropdown {
     .title {
        height : 34px !important;
        padding: 7px 12px !important;
        font-weight: 700;
        color : ${gray1};
      }
    }

  `;

  const dispatch = useAppDispatch();
  const { CurrentUserManager } = useContext(AngularServicesContext);
  const getLanguageTranslation = useLanguageTranslation();
  const availableLanguages = config.platformLanguages;
  const currentLanguage = CurrentUserManager.user.platformLanguage;

  const [isSaving, setIsSaving] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);


  const selectedIndex = availableLanguages.findIndex((lang) => lang === selectedLanguage);

  const handleLanguageChange = useCallback((lang) => {
    setIsSaving(true);
    setSelectedLanguage(lang);
    const prevLangIsRtl = config.rtlLanguages.includes(currentLanguage);
    const nextLangIsRtl = config.rtlLanguages.includes(lang);
    const shouldReload = prevLangIsRtl !== nextLangIsRtl;
    dispatch(updatePlatformLanguage(lang))
      .then(() => {
        CurrentUserManager.user.platformLanguage = lang;
        return CurrentUserManager.updateOrigamiLanguage(lang);
      })
      .then(() => {
        setIsSaving(false);
        if (shouldReload) {
          window.location.reload();
        }
      });
  }, [dispatch, currentLanguage, CurrentUserManager]);

  const LanguageItems: NvDropdownOption[] = React.useMemo(() => availableLanguages.map((lang) => ({
    id: lang,
    text: getLanguageTranslation(lang.toUpperCase()),
    type: 'text',
    callback: () => {
      handleLanguageChange(lang);
      setIsDropdownOpen(false);
    },
  })), [availableLanguages, getLanguageTranslation, handleLanguageChange]);


  return (
    <div css={styles}>
      {/* Language Preference */}
      <div>
        <div className='language_label page-subtitle header-row'>{t.LHS.ACCOUNT_MENU.LANGUAGE.PREFERENCE()}</div>
        <div className='text-regular'>{t.LHS.ACCOUNT_MENU.LANGUAGE.INFO_TEXT()}</div>
      </div>
      <div className='dropdown-select '>
        <NvDropdown
          showSelectedIndicator
          items={LanguageItems}
          initialIndex={selectedIndex}
          buttonStyle={NvDropdownButtonStyle.FORM_SMALL}
          align={NvDropdownAlign.CENTER}
          show={isDropdownOpen}
          onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
          ariaExpanded={isDropdownOpen}
        />
      </div>

      <div>
        <NvSavingOverlay
          isShown={isSaving}
          savingText={t.LANGUAGE.TRANSLATING()}
          isFullPage
        />
      </div>
    </div>
  );
};

export default LanguagePreferences;


